import FolderItem from './FolderItem';

export default FolderItem;
